// FINTRAC structured occupation record. These lists mirror
// bps-go/pkg/cardissuing/common/occupation.go and have to be kept in step with it.
export const occupationRoles = [
  'SENIOR_EXECUTIVE',
  'MIDDLE_MANAGER',
  'SUPERVISOR_TEAM_LEAD',
  'BUSINESS_OWNER_OPERATOR',
  'CONSULTANT_ADVISOR',
  'ACCOUNTING_FINANCE_PROFESSIONAL',
  'LEGAL_PROFESSIONAL',
  'ENGINEER_ARCHITECT',
  'IT_SOFTWARE_PROFESSIONAL',
  'SCIENTIST_RESEARCHER',
  'PHYSICIAN_DENTIST',
  'NURSE_ALLIED_HEALTH',
  'TEACHER_PROFESSOR',
  'SOCIAL_COMMUNITY_WORKER',
  'CLERGY_RELIGIOUS',
  'TECHNICIAN_TECHNOLOGIST',
  'SKILLED_TRADE_LICENSED',
  'EQUIPMENT_MACHINE_OPERATOR',
  'TRANSPORT_DRIVER_OPERATOR',
  'GENERAL_LABOURER',
  'FARMER_FISHER_RESOURCE_WORKER',
  'ADMINISTRATIVE_CLERICAL',
  'CUSTOMER_SERVICE_REPRESENTATIVE',
  'SALES_REPRESENTATIVE',
  'RETAIL_SALES_CASHIER',
  'FOOD_BEVERAGE_SERVICE',
  'PERSONAL_CARE_SERVICE',
  'CLEANING_MAINTENANCE',
  'SECURITY_PROTECTIVE_SERVICE',
  'POLICE_FIRE_MILITARY',
  'ELECTED_OFFICIAL_JUDICIARY',
  'GOVERNMENT_PUBLIC_ADMINISTRATION',
  'CREATIVE_ARTS_MEDIA',
  'ATHLETE_COACH_RECREATION',
  'STUDENT',
  'RETIRED',
  'UNEMPLOYED',
  'HOMEMAKER_CAREGIVER',
  'UNABLE_TO_WORK',
  'INDEPENDENT_MEANS_INVESTMENT_INCOME',
  'OTHER',
];

export const occupationSectors = [
  'AGRICULTURE_FORESTRY_FISHING',
  'MINING_OIL_GAS',
  'UTILITIES',
  'CONSTRUCTION',
  'MANUFACTURING',
  'WHOLESALE_TRADE',
  'RETAIL_TRADE',
  'TRANSPORTATION_WAREHOUSING',
  'INFORMATION_MEDIA_TELECOM',
  'FINANCE_INSURANCE',
  'REAL_ESTATE_RENTAL_LEASING',
  'PROFESSIONAL_SCIENTIFIC_TECHNICAL',
  'BUSINESS_MANAGEMENT_HOLDING',
  'ADMINISTRATIVE_SUPPORT_WASTE',
  'EDUCATION',
  'HEALTH_CARE_SOCIAL_ASSISTANCE',
  'ARTS_ENTERTAINMENT_RECREATION',
  'ACCOMMODATION_FOOD_SERVICES',
  'OTHER_SERVICES',
  'PUBLIC_ADMINISTRATION',
  'MONEY_SERVICES_CURRENCY_EXCHANGE',
  'GAMING_CASINO',
  'PRECIOUS_METALS_JEWELLERY',
  'VIRTUAL_CURRENCY_CRYPTO',
  'CANNABIS',
];

// Roles with no employment context to record. RETIRED and UNEMPLOYED are deliberately
// absent: their sector is the "retired from what" answer.
export const sectorExemptRoles = [
  'STUDENT',
  'HOMEMAKER_CAREGIVER',
  'UNABLE_TO_WORK',
  'INDEPENDENT_MEANS_INVESTMENT_INCOME',
];

export const OCCUPATION_OTHER = 'OTHER';

export const requiresOccupationSector = role =>
  Boolean(role) && !sectorExemptRoles.includes(role);

export const requiresOccupationOtherDetail = (role, sector) =>
  role === OCCUPATION_OTHER || sector === OCCUPATION_OTHER;
